import styles from'./style/index.scss';
import App from './app';

export default App;
